import React, { useEffect, useState } from "react";
import injectSheet from "react-jss";
import classNames from "classnames";
import _ from "lodash";
import axios from "axios";
import { HelpIcon } from "../../assets/icons/Icons";
import GustavModal from "../GustavModal/GustavModal";
import { GetData } from "../../utils/axios";
import SingleSelect2 from "../select/SingleSelect2";
import { manualPermissionChecker } from "../../utils/helpers";
import { GetUser } from "../../utils/UserFunctions";
import { DeviceType } from "../../utils/Enums";
import ReactPlayer from "react-player";

const HelpNavItem = ({
  toggleSubmenu,
  visible,
  classes,
  iconSize = "20px",
  className,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [videos, setVideos] = useState([]);
  const [user] = useState(GetUser());
  const [languages, setLanguages] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState(null);

  useEffect(() => {
    const cancelToken = axios.CancelToken.source();
    const cancelToken2 = axios.CancelToken.source();
    const getLanguages = async () => {
      const data = await GetData("/movie/getLanguages", cancelToken);
      if (!_.isEmpty(data)) {
        setLanguages(
          data.map((x) => {
            return { namn: x.sprak, id: x.sprakKod };
          })
        );
      }
    };
    const getVideos = async () => {
      const data = await GetData("/movie/getMovies", cancelToken2);
      if (!_.isEmpty(data)) {
        const { allPermissionsAsFlag } = user;
        let availableVideos = [];
        data.map((x) => {
          if (
            manualPermissionChecker(
              x?.webbkontoPermissionList,
              allPermissionsAsFlag
            )
          ) {
            availableVideos.push(x);
          }
        });

        setVideos(availableVideos);

        //Set first video
        setFirstVideo(
          availableVideos,
          JSON.parse(localStorage.getItem("helpFilter")),
          window.matchMedia("(max-width: 1023px)").matches
        );
      }
    };

    if (user) {
      getLanguages();
      getVideos();
      const storedFilter = JSON.parse(localStorage.getItem("helpFilter"));
      if (storedFilter) {
        setSelectedFilter(storedFilter);
      }
    }
    var windowWidth = window.matchMedia("(max-width: 1023px)");
    checkDevice(windowWidth);
    //windowWidth.removeEventListener("change", checkDevice);
    const isSafari = !!navigator.userAgent.match(/Version\/[\d.]+.*Safari/);
    if (isSafari) {
      windowWidth.addListener((value) => checkDevice(value));
    } else {
      windowWidth.addEventListener("change", checkDevice);
    }
    return () => {
      if (isSafari) {
        windowWidth.removeListener(() => checkDevice());
      } else {
        windowWidth.removeEventListener("change", checkDevice);
      }
      cancelToken.cancel();
      cancelToken2.cancel();
    };
  }, []);

  const handleOpenClose = () => {
    setIsOpen(!isOpen);
    if (toggleSubmenu) toggleSubmenu();
  };

  const handleChangeFilter = (value) => {
    localStorage.setItem("helpFilter", JSON.stringify(value));
    setSelectedFilter(value);
    setFirstVideo(videos, value, isMobile);
  };

  const setFirstVideo = (videoList, filter, isOnMobile) => {
    //Set first video

    const filteredVideos = videoList
      ?.filter((y) => (filter ? y.sprakKod === filter.id : y))
      ?.filter((y) => {
        if (isOnMobile) {
          return y.enhets !== DeviceType.Computer;
        } else {
          return y.enhets !== DeviceType.Mobile;
        }
      });
    if (!_.isEmpty(filteredVideos)) {
      const firstVideo = filteredVideos[0];
      if (firstVideo?.vimeoID) {
        setSelectedVideo(firstVideo?.vimeoID);
      }
    }
  };

  function checkDevice(value) {
    setIsMobile(value.matches);
  }

  const sortedList = videos
    ?.filter((y) => (selectedFilter ? y.sprakKod === selectedFilter.id : y))
    .filter((y) => {
      if (isMobile) {
        return y.enhets !== DeviceType.Computer;
      } else {
        return y.enhets !== DeviceType.Mobile;
      }
    });

  return (
    <>
      <button
        id="help"
        className={classNames(
          className,
          classes.button,
          visible && classes.active
        )}
        onClick={handleOpenClose}
      >
        <div id="help" style={{ display: "flex", alignItems: "center" }}>
          <div className={classes.buttonHolder}>
            <div id="help" className={classes.iconStyle}>
              <HelpIcon size={iconSize} />
            </div>
            <div id="help" className={classes.buttontext}>
              Hjälp
            </div>
          </div>
        </div>
      </button>
      {isOpen && (
        <GustavModal onCloseRequest={() => setIsOpen(false)} width="50rem">
          <div className={classes.modalContainer}>
            <div className={classes.header}>
              <div>
                <span className={classes.label}>Välj språk</span>
                <SingleSelect2
                  name="Välj språk"
                  label="sprak"
                  placeholder="Välj språk"
                  haveEmptyElement
                  elements={languages}
                  width="100%"
                  outerClassName={classes.dropDown}
                  handleValueNameChange={handleChangeFilter}
                  value={selectedFilter}
                />
              </div>

              <h1 className={classes.headerTitle}>Hjälpfilmer om E-tjänsten</h1>
            </div>
            <div className={classes.content}>
              <div
                className={classNames(
                  classes.videoListContainer,
                  _.isEmpty(sortedList) && classes.videoListContainerEmpty
                )}
              >
                {sortedList.map((x) => (
                  <div
                    key={x.id}
                    className={classNames(
                      classes.videoItem,
                      selectedVideo === x.vimeoID && classes.selectedVideoItem
                    )}
                    onClick={() => setSelectedVideo(x.vimeoID)}
                  >
                    {x.namn}
                  </div>
                ))}
                {_.isEmpty(sortedList) && (
                  <div className={classes.videoItem}>Inga video hittades</div>
                )}
              </div>
              <div className={classes.videoPlayerContainer}>
                <div
                  style={{
                    overflowY: "auto",
                  }}
                >
                  {selectedVideo && (
                    <div className={classes.iframeContainer}>
                      <ReactPlayer
                        light
                        controls
                        url={"https://player.vimeo.com/video/"+selectedVideo}
                        width="100%"
                        height="100%"
                        style={{ position: "absolute", top: 0, left: 0 }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </GustavModal>
      )}
    </>
  );
};

const styles = (theme) => ({
  modalContainer: {
    marginBottom: "20px",
  },
  content: {
    display: "flex",
    justifyContent: "space-between",
  },
  videoListContainer: {
    border: "1px solid #cbd2dc",
    borderRadius: "4px",
    //padding: "15px",
    minWidth: "180px",
  },
  videoItem: {
    cursor: "pointer",
    fontSize: "14px",
    color: "black",
    //paddingBottom: "4px",
    padding: "10px 15px 10px 15px",
    wordBreak: "break-word",
    "&:hover": {
      backgroundColor: "#c3d7ec",
    },
  },
  headerTitle: {
    marginLeft: "20px",
    color: "black",
  },
  selectedVideoItem: {
    backgroundColor: "#e8ecf0",
  },
  videoPlayerContainer: {
    width: "100%",
    height: "auto",
    marginLeft: "20px",
  },
  header: {
    display: "flex",
    marginBottom: "25px",
    alignItems: "flex-end",
  },
  dropDown: {
    minWidth: "180px",
  },
  iframeContainer: {
    position: "relative",
    display: "block",
    overflow: "hidden",
    "&:before": {
      display: "block",
      content: '""',
      paddingTop: "56.25%",
    },
    "& iframe": {
      position: "absolute",
      top: "0",
      bottom: "0",
      left: "0",
      width: "100%",
      height: "100%",
      border: "0",
    },
  },
  active: {
    color: "white!important",
    background: "#182d58!important",
  },
  iconStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "4px",
    marginTop: "3px",
  },
  button: {
    border: "0",
    display: "flex",
    height: "100%",
    padding: "0",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    textAlign: "center",
    cursor: "pointer",
    color: "white",
    font: "500 11px Roboto",
    lineHeight: "unset",
    outline: "none",
    width: "64px",
    "& svg g polygon": {
      fill: `${theme.themeHoverTextDarkColor}!important`,
    },
    "& svg path, circle, rect": {
      fill: `${theme.themeHoverTextDarkColor}!important`,
    },
    "&:hover": {
      backgroundColor: theme.themeHoverDark,
      color: theme.themeHoverTextDarkColor,
    },
  },
  label: {
    paddingLeft: "2px",
  },
  buttontext: {},
  buttonHolder: {},
  "@media (max-width: 1023px)": {
    modalContainer: {
      //minHeight: "500px",
    },
    button: {
      width: "unset !important",
      padding: "8px 0",
      marginBottom: "8px",
    },
    header: {
      flexDirection: "column-reverse",
      marginBottom: "10px",
      alignItems: "unset",
    },
    dropDown: {
      "& > button": {
        maxWidth: "unset",
        "& > div": {
          border: "solid 1px #cbd2dc",
        },
      },
    },
    content: {
      flexDirection: "column",
      alignItems: "center",
    },
    videoListContainer: {
      width: "100%",
      marginBottom: "8px",
      maxHeight: "100px",
      overflowY: "scroll",
      minHeight: "160px",
    },
    videoListContainerEmpty: {
      minHeight: "unset",
    },
    videoPlayerContainer: {
      marginLeft: "unset",
    },
    headerTitle: {
      marginLeft: "unset",
      marginBottom: "8px",
    },
    buttonHolder: {
      display: "flex",
    },
    iconStyle: { marginBottom: "0", marginTop: "0" },
    buttontext: { fontSize: "16px", paddingLeft: "16px", fontWeight: "normal" },
  },
});

export default injectSheet(styles)(HelpNavItem);
